/* eslint max-classes-per-file: "off" */

export class BirthdayError extends Error {}

export class WrongStoreBirthday extends BirthdayError {}
export class NotMyBirthday extends BirthdayError {}
